import { render, staticRenderFns } from "./ModeButtons.vue?vue&type=template&id=a08ae1e0&scoped=true"
import script from "./ModeButtons.vue?vue&type=script&lang=js"
export * from "./ModeButtons.vue?vue&type=script&lang=js"
import style0 from "./ModeButtons.vue?vue&type=style&index=0&id=a08ae1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ae1e0",
  null
  
)

export default component.exports